module.exports = __webpack_public_path__ + "static/media/APP_EarlyRiser_152x174_4.f48261e7.png";